import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import Slider from 'react-slick'

import Link from '../Link'

import * as styles from './index.module.css'

const LogoImages = ({ backgroundColor, components }) => {
  components = components ? components : []

  const settings = {
    arrows: false,
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  }

  const logos = components.filter((component) => component.type === 'logo')
  const logoCollections = new Array(Math.ceil(logos.length / 9))
    .fill(0)
    .map((_, index) => logos.slice(index * 9, (index + 1) * 9))
  const images = components.filter((component) => component.type === 'image')

  return (
    <div
      className={[styles.logoImagesContainer, 'logoImagesContainer'].join(' ')}
      style={{ backgroundColor }}
    >
      <Slider className={[styles.slick, 'slick'].join(' ')} {...settings}>
        {logoCollections.map((collection, idx) => (
          <div key={idx}>
            <div className={styles.logoWrapper}>
              {collection.map((logo, index) =>
                logo.link ? (
                  <Link
                    className={styles.logoContainer}
                    key={index}
                    to={logo.link}
                  >
                    <GatsbyImage
                      image={logo?.image?.gatsbyImageData}
                      className={styles.logo}
                      alt={logo?.image?.description}
                      imgStyle={{ objectFit: 'contain' }}
                    />
                  </Link>
                ) : (
                  <div className={styles.logoContainer} key={index}>
                    <GatsbyImage
                      image={logo?.image?.gatsbyImageData}
                      className={styles.logo}
                      alt={logo?.image?.description}
                      imgStyle={{ objectFit: 'contain' }}
                    />
                  </div>
                )
              )}
            </div>
          </div>
        ))}
      </Slider>

      <div className={styles.imageWrapper}>
        {images.map((image, index) =>
          image.link ? (
            <div className={styles.imageContainer} key={index}>
              <Link to={image.link}>
                <GatsbyImage
                  image={image?.image?.gatsbyImageData}
                  className={styles.image}
                  alt={image?.image?.description}
                  imgStyle={{ objectFit: 'cover' }}
                />
              </Link>
            </div>
          ) : (
            <div className={styles.imageContainer} key={index}>
              <GatsbyImage
                image={image?.image?.gatsbyImageData}
                className={styles.image}
                alt={image?.image?.description}
                imgStyle={{ objectFit: 'cover' }}
              />
            </div>
          )
        )}
      </div>
    </div>
  )
}

export default LogoImages
